import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import { MERCHANT_TAGS } from "../../../../enums/GlobalEnums";
import { Toggle } from "../../superAdminReusable/reusableSuperAdminButton/Toggle";

const IconUserModal = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  return (
    <>
      <tbody>
        <tr
          className="super_admin_all_users_table_body super-admin-list-icon-image cursor"
          onClick={showTr}
        >
          <td style={{ width: "10%" }}>{props?.index + 1}</td>
          {!props?.hexColor && (
            <th className="f12-700" style={{ width: "20%" }}>
              <div className="f12-500">{props && props.icon_code}</div>
            </th>
          )}
          <td style={{ width: "20%" }}>
            {props?.hexColor ? (
              <div
                style={{
                  backgroundColor: props?.hexColor,
                  color: "white",
                  padding: "0px 8px",
                  borderRadius: "24px",
                  width: "fit-content",
                }}
              >
                <span style={{ fontSize: "2vh" }}>{props?.name}</span>
              </div>
            ) : (
              <Image
                fluid
                //src={require("../../../../assets/images/Icon/bakery.png")}
                src={props.icon}
                className="inside-icon-image m-0"
                alt="Icon"
              />
            )}
          </td>
          <td style={{ width: "35%" }}>
            <div className="f12-500">{props.name}</div>
          </td>
          {props?.hexColor && (
            <th className="f12-700" style={{ width: "20%" }}>
              {props?.hexColor}
            </th>
          )}
          <td style={{ width: "10%" }}>
            <Toggle
              checked={props?.status === "APPROVED" ? true : false}
              toggleFunction={(e) =>
                props.handleStatus(
                  props,
                  props?.status === "APPROVED" ? "NOTAPPROVED" : "APPROVED"
                )
              }
            />
          </td>
          <td style={{ width: "15%" }}>
            <div className="d-flex align-items-center">
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={() =>
                  props.handleShowEdit(
                    props.name,
                    props.id,
                    props.icon,
                    props.description,
                    props.code,
                    props.icon_code,
                    props.photo
                  )
                }
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </Button>
              <Button
                variant="link"
                className="enIconBtn"
                onClick={props.handleShowDeleteIcon}
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/Delete.svg")}
                  alt="Delete"
                  title="Delete"
                  fluid
                />
              </Button>
            </div>
          </td>
        </tr>
        {TrDetail.TrDetail && (
          <tr className="super_admin_all_users_table_body super-admin-list-icon-image">
            <td colSpan="3">
              <div className="f16-500">Long description</div>
              <div className="f10-400">
                {props &&
                  props.description &&
                  props.description.length !== 0 ? (
                  <>{props.description} </>
                ) : (
                  <>Description not available</>
                )}
              </div>
            </td>
            <td colSpan="4">
              <div className="f10-400">
                <Image
                  fluid
                  //src={require("../../../../assets/images/Icon/bakery.png")}
                  src={props.photo}
                  className="inside-icon-image m-0"
                  alt="Icon"
                />
              </div>
            </td>
            <td colSpan="3">
              <div className="f16-500">Code</div>
              <div className="f10-400">
                {props?.code ? (
                  <>{props.code} </>
                ) : (
                  <>Code not available</>
                )}
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </>
  );
};

export default IconUserModal;
